import { useEffect, useState } from "react";
import numberToPersian from "./NumberToPersian";
import axiosConfig from "./axiosConfig";
import { useQuery } from "react-query";

const Timer = (props) => {
  const [seconds, setSeconds] = useState(props.mainsecond);
  const [minutes, setMinutes] = useState(props.mainminute);
  const [efState, setEfState] = useState(false);
  const [btnStart, setBtnStart] = useState("");
  const [btnPause, setBtnPause] = useState("dontshow");
  const [btnStop, setBtnStop] = useState("dontshow");
  let playState = props.playState;

  useEffect(() => {
    if (seconds > -1) {
      setTimeout(() => countDown(), 1000);
    } else {
      setSeconds(59);
    }
  });

  //   console.log("useLoop", efState);
  const countDown = () => {
    if (efState) {
      minutes === 0 && seconds === 0 ? setSeconds(0) : setSeconds(seconds - 1);
      if (seconds === 0) {
        minutes > 0 ? setMinutes(minutes - 1) : setMinutes(0);
      }
    }
  };

  const localPlaycode = localStorage.getItem("playcode");
  const { status1, data1, error1, isFetching1 } = useQuery(
    "todos1",
    async () => {
      const { data1 } = await axiosConfig.get(
        "send-timer.php?playcode=" +
          localPlaycode +
          "&minute=" +
          minutes +
          "&second=" +
          seconds
      );
      return data1;
    },
    {
      refetchInterval: 1000,
      //   enabled: queryRun,
    }
  );

  function setPlayStstus(playStatus) {
    try {
      axiosConfig
        .get(
          "set-play-timer-status.php?playcode=" +
            localPlaycode +
            "&play_status=" +
            playStatus
        )
        .then((response) => {
          console.log("set playStatus");
        });
    } catch (error) {
      console.log(error.errors);
    }
  }

  const StartTimer = () => {
    setEfState(true);
    setBtnStart("dontshow");
    setBtnStop("dontshow");
    setBtnPause("");
    setPlayStstus("play");
  };
  const PauseTimer = () => {
    setEfState(false);
    setBtnStart("");
    setBtnStop("");
    setBtnPause("dontshow");
    setPlayStstus("pause");
  };
  const StopTimer = () => {
    setEfState(false);
    setSeconds(0);
    setMinutes(2);
    setBtnPause("dontshow");
    setBtnStart("");
    setBtnStop("dontshow");
  };

  let preSecond = "";
  if (seconds < 10) {
    preSecond = "0";
  }

  return (
    <>
      <div className="row timerBox mt-4">
        <div className="col-md-12 col-12">
          <h6 className="full-width" style={{ textAlign: "center" }}>
            وقت مسابقه
          </h6>
        </div>
        <div className="col-md-8 col-8 btncoridor">
          <button
            className={"btn btn-sm btn-success btn-lg col-md-3 " + btnStart}
            onClick={StartTimer}
          >
            شروع
          </button>
          <button
            className={"btn btn-sm btn-warning btn-lg col-md-3 " + btnPause}
            onClick={PauseTimer}
          >
            وقفه
          </button>{" "}
          &nbsp; &nbsp;
          <button
            className={"btn btn-sm btn-danger btn-lg col-md-3 mr-3 " + btnStop}
            onClick={StopTimer}
          >
            از ابتدا
          </button>
        </div>
        <div
          className="col-md-4 col-4"
          style={{
            textAlign: "center",
            fontSize: "36px",
          }}
        >
          <p className="IRANSansBold" style={{ direction: "ltr" }}>
            {numberToPersian(minutes)} : {numberToPersian(preSecond)}
            {numberToPersian(seconds)}
          </p>
        </div>
      </div>
    </>
  );
};

export default Timer;
